// ResizeObserver loop limit exceeded error fix
// This error is harmless but annoying, especially in development

export const patchResizeObserver = () => {
  // First, let's silence the error globally
  const originalError = window.onerror;
  window.onerror = function(msg, url, line, col, error) {
    if (typeof msg === 'string' && (
      msg.includes('ResizeObserver loop') ||
      msg.includes('ResizeObserver loop completed') ||
      msg.includes('ResizeObserver loop limit exceeded')
    )) {
      console.log('Suppressed ResizeObserver error:', msg);
      return true; // Prevent error from showing
    }
    if (originalError) {
      return originalError(msg, url, line, col, error);
    }
    return false;
  };

  // Also catch unhandled promise rejections
  window.addEventListener('unhandledrejection', function(event) {
    if (event.reason && event.reason.message && 
        event.reason.message.includes('ResizeObserver loop')) {
      event.preventDefault();
    }
  });

  // More aggressive error catching for React's error boundaries
  window.addEventListener('error', function(e) {
    if (e.message && (
      e.message.includes('ResizeObserver loop') ||
      e.message.includes('ResizeObserver loop completed') ||
      e.message.includes('ResizeObserver loop limit exceeded')
    )) {
      e.stopImmediatePropagation();
      e.stopPropagation();
      e.preventDefault();
      return false;
    }
  }, true); // Use capture phase
  
  // Don't override Error constructor as it can break the app

  // Monkey patch ResizeObserver with requestAnimationFrame
  if (window.ResizeObserver) {
    const ResizeObserverOriginal = window.ResizeObserver;
    
    window.ResizeObserver = class ResizeObserver {
      private observer: any;
      private rafId: number | null = null;
      
      constructor(callback: ResizeObserverCallback) {
        const wrappedCallback: ResizeObserverCallback = (entries, observer) => {
          if (this.rafId) {
            cancelAnimationFrame(this.rafId);
          }
          
          this.rafId = requestAnimationFrame(() => {
            callback(entries, observer);
            this.rafId = null;
          });
        };
        
        this.observer = new ResizeObserverOriginal(wrappedCallback);
      }
      
      observe(target: Element, options?: ResizeObserverOptions) {
        return this.observer.observe(target, options);
      }
      
      unobserve(target: Element) {
        if (this.rafId) {
          cancelAnimationFrame(this.rafId);
          this.rafId = null;
        }
        return this.observer.unobserve(target);
      }
      
      disconnect() {
        if (this.rafId) {
          cancelAnimationFrame(this.rafId);
          this.rafId = null;
        }
        return this.observer.disconnect();
      }
    } as any;
  }
};